module.exports = __webpack_public_path__ + "static/img/enterpriseBig3.a072e73f.png";